export default __webpack_public_path__ + "static/media/register.6d4ef56c.png";